module.exports = __webpack_public_path__ + "img/holiday_3_vegas.a8d88011.jpg";